var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_227",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(207 184)",
    fill: "#7FC4FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_604",
    d: "M48.74-27.847s-3.944,5.335-5.181,6.34S14.138-11.583,9.664-5.574C3.906,2.155,1.659,19.632.5,34.21H126.672c-1.159-14.578-3.405-32.054-9.163-39.784-4.475-6.009-32.657-14.927-33.9-15.932s-5.18-6.34-5.18-6.34h-.271v-5.846A33.194,33.194,0,0,0,82-39.718a27.545,27.545,0,0,0,1.455-6.808c4.642-2.13,5.2-9.554,5.4-13.715.1-2.17-1.012-2.233-2.186-1.724.049-.445.082-.9.117-1.353,1.229-4.3,2.343-8.638,3.312-13.007.743-3.349,1.341-7.114-.522-9.995l1.949.256c-2.616-6.013-8.628-10.082-15-11.619s-13.09-.833-19.491.594c-3.253.726-6.664,1.794-8.9,4.206a30.39,30.39,0,0,0-8.449,1.43l3.025,1.286a22.861,22.861,0,0,0-5.921,18.127,22.457,22.457,0,0,0,2.725,8.182c.206.578.42,1.156.64,1.728-.992-.292-1.827,0-1.738,1.888.2,4.163.757,11.592,5.406,13.718a27.4,27.4,0,0,0,1.455,6.805,33.1,33.1,0,0,0,3.73,5.888v5.983H48.74",
    transform: "translate(-0.501 98.548)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_603",
    d: "M-63,496.781H610.781V-177H-63Z",
    transform: "translate(63 177)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar",
    transform: "translate(-207 -184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_227-2",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(207 184)",
    fill: "#7FC4FD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_\\u043C\\u0430\\u0441\\u043E\\u043A_16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1603",
    transform: "translate(230.499 299.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1600",
    transform: "translate(-12.499 -98.548)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1599",
    transform: "translate(-85.572 -105.719)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_602",
    d: "M-4.5-103.548H135.148V42.685H-4.5Z",
    transform: "translate(83.333 202.529)",
    fill: "#5996C1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPic);
export default __webpack_public_path__ + "static/media/userPic.0ef58503ed8d4e53bad48cc5cd47abae.svg";
export { ForwardRef as ReactComponent };